const toolLevelType = {
    School: "School",
    Personal: "Personal",
    StudyGroup: "StudyGroup",
};

export default toolLevelType;
